import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaPrompt } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaPrompt";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";

function Confirmation({
  onSubmit,
  onClose,
  onCancel,
  question,
  description,
  negativeText,
  positiveText,
  swapButtons,
}) {
  const primaryButton = () => (
    <FixaButton
      text={positiveText}
      type="primary"
      onClick={() => onSubmit(true)}
      aria-label={positiveText}
    />
  );
  const secondaryButton = () => (
    <FixaButton
      text={negativeText}
      type="secondary"
      onClick={() => onCancel(false)}
      aria-label={negativeText}
    />
  );
  const buttons = () => (
    <FixaModalFooter>
      {swapButtons ? primaryButton() : secondaryButton()}
      {swapButtons ? secondaryButton() : primaryButton()}
    </FixaModalFooter>
  );
  return (
    <FixaModal handleCloseBtn={onClose} visible={true}>
      <FixaPrompt
        aria-label={question}
        footer={buttons()}
        header={<FixaModalHeader title={question} />}
        title=""
        titleId=""
      >
        <p>{description}</p>
      </FixaPrompt>
    </FixaModal>
  );
}

export default Confirmation;
